'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Common.SeasonColors', dependencies).factory('SeasonColorService', require('./services/SeasonColorService'));